import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './responsive.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./store"
import { FormProvieder } from './ContextApi';
import Toast from './common/Toast';


ReactDOM.render(
  <>
    <Provider store={store}>
      <Toast />
      <FormProvieder>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </FormProvieder>
    </Provider>
  </>,
  document.getElementById("root")
);

reportWebVitals();
